var DEF_WASM_PATH = '/js/datasymbol/datasymbol-sdk.wasm';